import React from 'react';
import ContactInfo from '../../components/ContactInfo/ContactInfo';
import Container from '../../components/Container/Container';
import Form from '../../components/Form/Form';
import Ribbon from '../../components/Ribbon/Ribbon';
import s from './contacts.module.css';

export default function Contacts() {
  return (
    <>
      <div className={s.drivers}>
        <Container>
          <section>
            <h1 className={s.titleSection}>контакти</h1>
          </section>
        </Container>
      </div>
      <section className={s.section}>
        <div className={s.ribbon}>
          <Ribbon />
        </div>
        <Container>
          <h2 className={s.title}>Зв'яжіться з нами</h2>
          <div className={s.wrapper}>
            <Form />
            <ContactInfo />
          </div>
        </Container>
      </section>
    </>
  );
}
